import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=688f764e&scoped=true"
import script from "./viewForm.vue?vue&type=script&lang=js"
export * from "./viewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688f764e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688f764e')) {
      api.createRecord('688f764e', component.options)
    } else {
      api.reload('688f764e', component.options)
    }
    module.hot.accept("./viewForm.vue?vue&type=template&id=688f764e&scoped=true", function () {
      api.rerender('688f764e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/customerCSG/components/viewForm.vue"
export default component.exports